import React, { useState ,useEffect} from "react";
import style from "./StatCard.module.css";
import questionicon from "../../../assests/questionicon.svg";
import Clockicon from "../../../assests/Clockicon.svg";
import star from "../../../assests/star.svg";
import StatCard from "./StatCard";
import { baseurl } from "../../Url";


const PracticeInsights = () => {
  const token = JSON.parse(localStorage.getItem("access-token"));
  const UserID = localStorage.getItem("USERID");
  const OrgID = localStorage.getItem("ORGID");

  const [dateForDD, setDateForDD] = useState("week");
  const [mainData,setMainData]=useState("")

  const handleDDDate = (dateType) => {
    setDateForDD(dateType);
    console.log("Selected Date Range:", dateType);
  };
  async function practiceInsight() {
      try {
    const res = await fetch(`${baseurl}/practice/insight`, {
      method: "POST",
      body: JSON.stringify({
        user_id: UserID,
        key: dateForDD, 
        org_id: OrgID
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();
    setMainData(data.data); 
    console.log("Fetched Insights:", data.data);
  } catch (error) {
    console.error("Error fetching insights:", error);
  }
}
useEffect(() => {
  practiceInsight();
}, [dateForDD]); 

  return (
    <div className={style.Container}>
      <div className={style.HeaderContainer}>
        <p> Practice Insights</p>
        <div className={style.learningSubHeaderLeft}>
          <div
            className={`${style.subHeaderCard} ${
              dateForDD === "week" ? style.selectedSubHeaderCard : ""
            }`}
            onClick={() => handleDDDate("week")}
          >
            <p>W</p>
          </div>
          <div
            className={`${style.subHeaderCard} ${
              dateForDD === "month" ? style.selectedSubHeaderCard : ""
            }`}
            onClick={() => handleDDDate("month")}
          >
            <p>M</p>
          </div>
          <div
            className={`${style.subHeaderCard} ${
              dateForDD === "year" ? style.selectedSubHeaderCard : ""
            }`}
            onClick={() => handleDDDate("year")}
          >
            <p>YTD</p>
          </div>
        </div>
      </div>

      <div className={style.valueContainer}>
        <StatCard
          title="Answered"
          value={mainData?.total_answered || 0}
          description="questions"
          bgColor="#FFFFFF"
          textColor="rgba(255, 136, 0, 1)"
          icon={questionicon}
        />

        <StatCard
          title="Spent"
          value={ mainData? mainData.hours === 0  ? `${mainData.minutes}`  : `${String(mainData.hours).padStart(2, "0")}:${String(mainData.minutes).padStart(2, "0")}`: "00:00"}
          description={mainData?.hours === 0 ? `minutes` : `hours`}
          bgColor="#FFFFFF"
          textColor="rgba(47, 195, 235, 1)"
          icon={Clockicon}
        />

        <StatCard
          title="Practised"
          value={mainData?.total_skills_done || 0}
          description={`skills out of ${mainData?.total_skills || 0}`}
          bgColor="#FFFFFF"
          textColor="rgba(253, 189, 16, 1)"
          icon={star}
        />
      </div>
    </div>
  );
};

export default PracticeInsights;
